var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10h1v2h-1v-2zM5 4h1v2H5V4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 100 16A8 8 0 008 0zM4 3.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-3zm8 9a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v3zm-.056-8.655l-7 9a.56.56 0 01-.789.098.563.563 0 01-.099-.789l7-9a.563.563 0 01.888.69z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentIcon);
export default __webpack_public_path__ + "static/media/percent-icon.b5342f5c9799d477cc454e5073a3e935.svg";
export { ForwardRef as ReactComponent };